export default "__VITE_ASSET__929ecd98__"